module.exports = __webpack_public_path__ + "static/img/NSW-8.c08f2e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-8.jpg
// module id = mULF
// module chunks = 0